import React, { FC } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';

interface CustomConfirmationModalProps {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title?: string;
    message?: string;
    confirmButtonLabel?: string;
    cancelButtonLabel?: string;
    confirmButtonColor?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    cancelButtonColor?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}

const CustomConfirmationModal: FC<CustomConfirmationModalProps> = ({
    open,
    onConfirm,
    onCancel,
    title = 'Confirm Action',
    message = 'Are you sure you want to proceed?',
    confirmButtonLabel = 'Confirm',
    cancelButtonLabel = 'Cancel',
    confirmButtonColor = 'primary',
    cancelButtonColor = 'secondary',
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            PaperProps={{ style: { borderRadius: 12, padding: 16 } }} // optional paper padding if needed
        >
            <DialogTitle sx={{ pb: 1.5, px: 2, pt: 2 }}>
                <Typography variant="h6">{title}</Typography>
            </DialogTitle>

            <DialogContent sx={{ px: 2, pb: 2 }}>
                <Typography variant="body2" fontWeight={200} color='Grey'>
                    {message}
                </Typography>
            </DialogContent>

            <DialogActions sx={{ px: 2, pb: 2, pt: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Button onClick={onCancel} color={cancelButtonColor}>
                    {cancelButtonLabel}
                </Button>
                <Button onClick={onConfirm} color={confirmButtonColor} variant="contained">
                    {confirmButtonLabel}
                </Button>
                </div>
            </DialogActions>
        </Dialog>

    );
};

export default CustomConfirmationModal;
